
import CustomerService from '../services/CustomerService';
import EventDispatcher from "../framework/EventDispatcher";

export const GET_CUSTOMER_CONFIG = "GET_CUSTOMER_CONFIG";
export default function reducer(state = {}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(GET_CUSTOMER_CONFIG):
		const {listData} = action.data;
		return {
			...state,
			listData
		};
		break;
		default:
		return state;
	}
}
export function getCustomerConfiguration() {
  return dispatch => {
    CustomerService.getCustomerConfiguration()
    .then(response => {
      const {actionStatus, titles} = response || {};
      if (actionStatus == null || actionStatus.status === "FAIL") {
        this.fail(actionStatus);
      } else {
        CustomerService.getCustomerAccountConfiguration().then(response => {
          const {actionStatus, paymentMethods} = response || {};
          if (actionStatus == null || actionStatus.status === "FAIL") {
            this.fail(actionStatus);
          } else {
            CustomerService.getCountryList().then(response => {
              const {actionStatus, countries} = response || {};
              if (actionStatus == null || actionStatus.status === "FAIL") {
                this.fail(actionStatus);
              } else {
                const listData = {countries, paymentMethods, titles};
                EventDispatcher.success(dispatch, GET_CUSTOMER_CONFIG, {listData});
              }
            })
          }
        })
      }
    })
    .catch(error => {
      EventDispatcher.error(dispatch, GET_CUSTOMER_CONFIG, {error});
    });
  };
}



// WEBPACK FOOTER //
// ./src/opencell/actions/ListActions.js